import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
var _excluded = ["layout", "href", "children", "className"];
import clsx from "clsx";
import React from "react";
import NextLink from "next/link";
import { createMemoClass } from "../create-memo-class";
import { useRouter } from "next/router";
import { jsx as _jsx } from "react/jsx-runtime";
export var Link = _ref => {
  var {
    layout,
    href,
    children,
    className
  } = _ref,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded);

  var classes = useLinkClass({
    layout
  });
  var router = useRouter();

  if (href && typeof href === 'string' && !router.query.preview) {
    if (href != null && href.startsWith("http")) return /*#__PURE__*/_jsx("a", _extends({
      target: "_blank",
      className: clsx(classes, className),
      href: href
    }, rest, {
      children: children
    }));
    return /*#__PURE__*/_jsx(NextLink, {
      href: href,
      passHref: true,
      children: /*#__PURE__*/_jsx("a", _extends({
        className: clsx(classes, className)
      }, rest, {
        children: children
      }))
    });
  }

  return /*#__PURE__*/_jsx("a", _extends({
    className: clsx(classes, className)
  }, rest, {
    children: children
  }));
};
var useLinkClass = createMemoClass(props => {
  var layouts = {
    block: "link-block",
    external: "link-external"
  };
  var classes = clsx("link", layouts[props.layout]);
  return classes;
});
//# sourceMappingURL=link.js.map